import { FC } from "react"
import { Brand } from "../../../../types"
import BrandOverview from "./overview"
import BrandReviews from "./reviews"

interface Props {
  brand: Brand
}

const BrandDetails: FC<Props> = ({ brand }) => (
  <div className="p-6 max-w-3xl">
    <BrandOverview brand={brand} />
    <BrandReviews brand={brand} />
  </div>
)

export default BrandDetails
